import baseApi from "./base"
import { Apply1Request, Apply1Response} from "./types/apply"
import { RefreshCaptcha1Request, RefreshCaptcha1Response } from "./types/refreshCaptcha"
import { BaseResponse } from "./types/common"
import { GetCaptcha1Response, GetCaptcha1Request } from "./types/captcha"

const api = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getTokenByTckn1: builder.mutation<BaseResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body : {
          tckn: "90" + body.replace(/\s/g, ""),
          functionCode: "SPE0022",
          NextTransactionUrl: "Facebook/SocialMediaPortalCreateSession/GetTokenByTckn1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body : {
          guid : "90" + body.guid.replace(/\s/g, ""),
          TokenSessionId : body.TokenSessionId,
          functionCode: "SPE0022",
          NextTransactionUrl: "Facebook/JuzdanAppDownload/GetCaptcha1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    refreshCaptcha: builder.mutation<RefreshCaptcha1Response, RefreshCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          guid : "90" + body.guid.replace(/\s/g, ""),
          functionCode: "SPE0022",
          NextTransactionUrl: "Facebook/JuzdanAppDownload/RefreshCaptcha1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply1: builder.mutation<Apply1Response, Apply1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          guid: body.guid,
          captcha: body.captcha,
          cellPhoneNumber: body.cellPhoneNumber,
          kvkk: body.kvkk,
          NextTransactionUrl: "Facebook/JuzdanAppDownload/Apply1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    })
  })
})

export const { useGetTokenByTckn1Mutation, useGetCaptchaMutation, useRefreshCaptchaMutation, useApply1Mutation } = api

export default api
